import { createContext } from 'react';

import type { TranslationKey } from './messages';

export type Language = 'en' | 'es';
export type TranslationParams = Readonly<Record<string, number | string>>;

export interface I18nValue {
  readonly language: Language;
  readonly locale: 'en-US' | 'es-US';
  readonly setLanguage: (language: Language) => Promise<void>;
  readonly t: (key: TranslationKey, params?: TranslationParams) => string;
}

export const I18nContext = createContext<I18nValue | null>(null);
